module.exports = __webpack_public_path__ + "img/fitness5.a9790377.png";